import { useMemo } from 'react';
import type {
  BoundaryGroupId, BoundaryId,
} from '~/store/boundaries/boundaryIdentifier.type';
import { useBoundaryTerritoryAssignments } from '~/store/boundaryTerritoryDetails/boundaryTerritoryDetails.selectors';
import type { BoundaryFiltersGeneric } from '~/store/mapSettings/toolsState/boundary/mapSettingsToolsStateBoundary.selectors';
import type { FilteredBoundaryItems } from '~/store/mapSettings/toolsState/boundary/mapSettingsToolsStateBoundary.state';

export const useBoundaryIdsFromBoundaryFilter = <T extends FilteredBoundaryItems>(
  boundaryFilter: BoundaryFiltersGeneric<T>,
): ReadonlyMap<BoundaryGroupId, ReadonlySet<BoundaryId>> => {
  const boundaryTerritoryAssignments = useBoundaryTerritoryAssignments();

  return useMemo(() => {
    const newBoundariesMap = new Map<BoundaryGroupId, ReadonlySet<BoundaryId>>();

    boundaryFilter.entries.forEach(entry => {
      const boundaryTerritoryAssignmentsForGroup = boundaryTerritoryAssignments.get(entry.boundaryGroupId);
      const territoryBoundaryIds = new Set<BoundaryId>();
      if (boundaryTerritoryAssignmentsForGroup) {
        entry.filter.filteredBoundaryTerritories.map((boundaryTerritoryId) => {
          boundaryTerritoryAssignmentsForGroup.territoryAssignments
            .get(boundaryTerritoryId)?.forEach(boundaryId => territoryBoundaryIds.add(boundaryId));
        });
      }

      entry.filter.filteredBoundaries.forEach(boundaryId => territoryBoundaryIds.add(boundaryId));
      if (territoryBoundaryIds.size) {
        newBoundariesMap.set(entry.boundaryGroupId, territoryBoundaryIds);
      }
    });

    return newBoundariesMap;
  }, [boundaryFilter.entries, boundaryTerritoryAssignments]);
};
